import React from 'react';
import { MessageCircle, Search, Calculator, FileText, AlertTriangle } from 'lucide-react';

const WhatsAppInteraction = () => {
  const examples = [
    {
      icon: <Search className="h-5 w-5 text-[#25D366]" />,
      text: "Verifica ônus/ações nesse edital."
    },
    {
      icon: <Calculator className="h-5 w-5 text-[#25D366]" />,
      text: "Qual a faixa de valor pra revenda em [cidade]?"
    },
    {
      icon: <FileText className="h-5 w-5 text-[#25D366]" />,
      text: "Faz a viabilidade para flip vs. locação."
    },
    {
      icon: <AlertTriangle className="h-5 w-5 text-[#25D366]" />,
      text: "Resumo de pendências na matrícula."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-slate-900">
            Interaja com o agente (WhatsApp)
          </h2>
          <p className="text-xl text-slate-600">
            Converse com o ImóvelIA quando quiser. Exemplos:
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-[#25D366]/5 p-8 rounded-2xl border border-[#25D366]/10">
            <div className="space-y-4 mb-8">
              {examples.map((example, index) => (
                <div key={index} className="bg-white p-4 rounded-lg shadow-sm border border-slate-100 flex items-center gap-3">
                  <div className="bg-[#25D366]/10 p-2 rounded-lg">
                    {example.icon}
                  </div>
                  <span className="text-slate-700 italic">"{example.text}"</span>
                </div>
              ))}
            </div>

            <div className="text-center">
              <a
                href="https://wa.me/5516999631188?text=Quero%20iniciar%20o%20Beta%20do%20ImóvelIA&utm_source=grupoCB&utm_medium=whatsapp&utm_campaign=beta_aberto"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white px-6 py-3 rounded-lg font-medium transition-colors"
              >
                <MessageCircle className="h-5 w-5" />
                Abrir conversa
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppInteraction;